import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_PAGE_NAMES } from '../../../../shared/mixpanel';
import { createReportIdeasHubBtnClicked } from '../../../../shared/mixpanel/events';
import store from '../store';
import { reportPageView } from './reportPageView';

const enrichment = {
    [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.DISCOVER_LOGO_IDEAS,
} as const;

const reportIdeasHubBtnClicked = createReportIdeasHubBtnClicked(store, enrichment);

export { reportPageView, reportIdeasHubBtnClicked };
